import { render, staticRenderFns } from "./MessageLocalContent.vue?vue&type=template&id=92b75f48&"
import script from "./MessageLocalContent.vue?vue&type=script&lang=js&"
export * from "./MessageLocalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports